import {Component, ElementRef, HostBinding, Input, Optional, ChangeDetectionStrategy} from '@angular/core';
import {Widget} from '../../../../../components/layout/widget/widget';
import {CellComponent} from '../../cell/cell.component';
import {WidgetCommonAction} from '../widget-common-action';
import {WidgetSettingsAction} from '../widget-settings';

const SETTINGS_OPENED_CLASS = '-settings-opened';

@Component({
    selector: 'widget-header',
    templateUrl: './widget-header.component.html',
    styleUrls: ['./widget-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetHeaderComponent {

    @Input()
    public widget: Widget;

    @Input()
    public isGroupLinkingDisabled?: boolean = false;

    @HostBinding(`class.${SETTINGS_OPENED_CLASS}`)
    public get isSettingsOpened(): boolean {
        return this.cellComponent && this.cellComponent.settingsOpenedForWidget === this.widget;
    }

    constructor(
        public widgetHeaderElementRef: ElementRef,
        @Optional()
        private cellComponent: CellComponent
    ) {}

    public onOpenSettingsClick(event: MouseEvent): void {

        // Stop event bubbling, in order to prevent side effects, since the action is handled here.
        event.stopPropagation();

        this.widget.action$.next({
            type: WidgetSettingsAction.OPEN_WIDGET_SETTINGS
        });
    }

    public onDetachClick(event: MouseEvent): void {

        // Stop event bubbling, in order to prevent side effects, since the action is handled here.
        event.stopPropagation();

        this.widget.action$.next({
            type: WidgetSettingsAction.DETACH_WIDGET
        });
    }

    public onRemoveWidgetClick(event: MouseEvent): void {

        // Stop event bubbling, in order to prevent side effects, since the action is handled here.
        event.stopPropagation();

        this.widget.action$.next({
            type: WidgetCommonAction.REMOVE_WIDGET
        });
    }

}
